module.exports = __webpack_public_path__ + "static/media/detail_product.d2edf255.png";